import { useDispatch, useSelector } from "react-redux";
import { Grid, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { changeFilter } from "../slice/FacilityLocationTypeFilterSlice";
import { useEffect } from "react";

const FacilityLocationTypeFilter = () => {
    const dispatch = useDispatch();
    const { list, appliedFilter } = useSelector((state) => state.facilityLocationTypeFilter);
    const { selectedFacility } = useSelector((state) => state.stationList);

    const changeHandler = (e) => {
        const selectedPowerType = e.target.value;
        const matchingItem = list.find(item => item[0]===selectedPowerType)
        dispatch(changeFilter(matchingItem))
    };

    useEffect(()=>{
        if(selectedFacility?.name !== "All")
            dispatch(changeFilter(["all","All"]));
    },[selectedFacility])

    return (
        <Grid container>
            <FormControl sx={{ minWidth: "150px" }}>
                <InputLabel id="month-select-label">Select Facility Location Type </InputLabel>
                <Select
                    labelId="month-select-label"
                    label="Select Facility Location Type "
                    value={appliedFilter[0]}
                    onChange={changeHandler}
                    disabled={selectedFacility?.name !== "All"}
                    sx={{ height: "49px", backgroundColor: "white", textTransform: "capitalize" }}
                    style={{ fontSize: "15px" }}
                >
                    {list &&
                        list.map((item, index) => (
                            <MenuItem key={index} value={item[0]} sx={{ fontSize: "15px", textTransform: "capitalize" }}>
                                {item[1]}
                            </MenuItem>
                        ))}
                </Select>
            </FormControl>
        </Grid>
    );
};

export default FacilityLocationTypeFilter;
